import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RaceAdminSummaryDto } from '@aoe/client';

@Component({
  selector: 'aoe-duplicate-race',
  imports: [MatDialogModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './duplicate-race.component.html',
  styleUrl: './duplicate-race.component.scss',
})
export class DuplicateRaceComponent implements OnInit {

  duplicateFg!: FormGroup;



  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { race: RaceAdminSummaryDto },
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<DuplicateRaceComponent>
  ) { }

  ngOnInit(): void {

    const formattedStartTime = this.data.race?.startTime
      ? new Date(this.data.race.startTime).toISOString().slice(0, 16)
      : '';

    this.duplicateFg = this.fb.group({
      startTime: new FormControl(formattedStartTime, [Validators.required]),
      name: new FormControl(this.data.race.name, [Validators.required, Validators.maxLength(150)]),
      slug: new FormControl(this.data.race.name, [Validators.required, Validators.maxLength(50)])
    })
  }

  // Méthode centralisée pour générer les messages d'erreur dynamiquement
  getErrorMessage(controlName: string): string {
    const control = this.duplicateFg.get(controlName);

    if (control?.hasError('required')) {
      return 'Ce champ est obligatoire.';
    }

    if (control?.hasError('maxlength')) {
      const maxLength = control.errors?.['maxlength'].requiredLength;
      return `La longueur maximale est de ${maxLength} caractères.`;
    }

    return 'Champ invalide.';
  }

  submit(): void {
    if (this.duplicateFg.valid) {
      this.dialogRef.close(this.duplicateFg.value);
    } else {
      this.duplicateFg.markAllAsTouched();
    }
  }

}
